import { UPDATE_WHEEL } from '../constants/ActionTypes'

export default function wheel(state = 0, action) {
  if (action.type === UPDATE_WHEEL) {
    const { scrollTop } = action;
    return scrollTop;
  }
  return state;
};



// WEBPACK FOOTER //
// ./src/reducers/wheel.js